import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/delta/delta-logo.webp")